import { ApiError } from '../api/client'
import { useT } from '../i18n'

/** Platzhalter im Raster, damit die Seite beim Eintreffen der Daten nicht springt. */
export function RasterSkelett({ anzahl = 8 }: { anzahl?: number }) {
  return (
    <ul className="raster" aria-hidden="true">
      {Array.from({ length: anzahl }, (_, i) => (
        <li className="kachel" key={i}>
          {/* Derselbe Rahmen wie in der echten Kachel — sonst hat der
              Platzhalter ein anderes Seitenverhältnis als das Bild, und die
              Seite springt beim Eintreffen der Daten genau so weit. */}
          <div className="kachel-rahmen skelett skelett-bild" />
          <div className="skelett skelett-zeile" style={{ width: '75%' }} />
          <div className="skelett skelett-zeile" style={{ width: '40%' }} />
        </li>
      ))}
    </ul>
  )
}

export function Ladehinweis({ text }: { text?: string }) {
  const t = useT()
  return (
    <p className="hinweis" role="status">
      {text ?? t('zustand.laedt')}
    </p>
  )
}

/**
 * Eine Fehlermeldung, die sagt, was zu tun ist.
 *
 * Der Rohtext des Servers steht bewusst nicht allein da: „Fehler 500" hilft
 * niemandem beim Einkaufen. Was der Server schickt, kommt als Zusatz dazu.
 */
export function Fehlerhinweis({ fehler }: { fehler: unknown }) {
  const t = useT()
  const text =
    fehler instanceof ApiError && fehler.status === 0
      ? t('zustand.nichtErreichbar')
      : t('zustand.schiefgegangen')

  // Der Zusatz ist die Meldung des Servers — sie bleibt, wie sie ankommt
  // (siehe i18n.tsx). Beim Status 0 hat der Server aber gar nicht geantwortet:
  // Dort stünde nur unser eigener Platzhalter aus client.ts, und der sagte
  // dasselbe noch einmal — auf einer englischen Seite obendrein auf Deutsch.
  const zusatz =
    fehler instanceof ApiError && fehler.status === 0
      ? null
      : fehler instanceof Error
        ? fehler.message
        : null

  return (
    <div className="hinweis hinweis-fehler" role="alert">
      <p style={{ margin: 0 }}>{text}</p>
      {zusatz && (
        <p style={{ margin: '0.5rem 0 0', fontSize: '0.86rem' }}>
          {/* Der Zusatz selbst bleibt, wie der Server ihn schickt — siehe
              i18n.tsx: Seine Sätze kennen diesen Laden, das Ladenfenster nicht. */}
          <span className="nur-fuer-screenreader">{t('zustand.meldungServer')}</span>
          {zusatz}
        </p>
      )}
    </div>
  )
}

export function Leerhinweis({ text }: { text: string }) {
  return <p className="hinweis">{text}</p>
}
